<div class="course-container mt-5 pt-5 mx-3 row">
  <div class="col-12 col-lg-3 left-card">
    <h1 class="m-3 mb-4">{{ data.courseName }}</h1>

    <p-accordion [activeIndex]="lesson ? lesson.currentChapterIndex : 0">
      <p-accordionTab *ngFor="let item of data.courseList" [header]="item.title" >
        <div
          class="d-flex align-items-center pt-2 pointer"
          *ngFor="let detail of item.lessons"
          (click)="openLesson(detail)"
          [ngStyle]="{ 'color': detail.name == (lesson ? lesson.name : '') ? '#3382cc' : '' }"
        >
          <i
            class="fs-5"
            [ngClass]="
              detail.played
                ? 'bi bi-check-circle-fill text-success'
                : 'bi bi-play-circle'
            "
          ></i>
          <h6 class="px-2 m-0 font-style">{{ detail.name }}</h6>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div *ngIf="lesson && !showFeedback" class="col-12 col-lg-9">
    <video width="100%" height="500" controls controlsList="nodownload" #videoPlayer></video>
    <div class="d-flex justify-content-between m-3">
      <h4>{{ lesson.name }}</h4>
     <div class="d-flex gap-3">
  <button 
    class="nav-btn" 
    [disabled]="!lesson.prevLesson" 
    (click)="lesson.prevLesson && openLesson(lesson.prevLesson)"
  >
    &#10094; السابق
  </button>
  <button 
    class="nav-btn" 
    [disabled]="!lesson.nextLesson" 
    (click)="lesson.nextLesson && openLesson(lesson.nextLesson)"
  >
    التالي &#10095;
  </button>
</div>
    </div>
  </div>
  <div *ngIf="showFeedback" class="col-12 col-lg-9 my-2 p-3 rounded">
    <h5 class="mb-3">اختبار تحديد مستوي</h5>
    
<p>الفورم لا تعمل؟ <a class="text-black" href="https://docs.google.com/forms/d/e/1FAIpQLSdXZv8uuOE7leQrhS0INmc13DN8ZEpLXV2ETjqiah0QdBkFwQ/viewform?embedded=true">اضغط هنا</a></p>
    <iframe
      dir="rtl"
      src="https://docs.google.com/forms/d/e/1FAIpQLSdXZv8uuOE7leQrhS0INmc13DN8ZEpLXV2ETjqiah0QdBkFwQ/viewform?embedded=true"
      width="100%"
      height="600"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
    >جارٍ التحميل…</iframe>
  </div>
</div>
